/**
 * @generated SignedSource<<43e49bdd0f21a309b643ec99888f73dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type introduceEditorQuery$variables = {
  userId?: string | null | undefined;
};
export type introduceEditorQuery$data = {
  readonly insurance_agent_connection: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly contenthtml: string | null | undefined;
        readonly contentjson: string | null | undefined;
        readonly id: string;
        readonly userpubliccontent: boolean;
      };
    }>;
  };
};
export type introduceEditorQuery = {
  response: introduceEditorQuery$data;
  variables: introduceEditorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "userId"
              }
            ],
            "kind": "ObjectValue",
            "name": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "insurance_agentConnection",
    "kind": "LinkedField",
    "name": "insurance_agent_connection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "insurance_agentEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "insurance_agent",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contenthtml",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contentjson",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userpubliccontent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "introduceEditorQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "introduceEditorQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e07a270b1044a4a0251b1db7658d65f3",
    "id": null,
    "metadata": {},
    "name": "introduceEditorQuery",
    "operationKind": "query",
    "text": "query introduceEditorQuery(\n  $userId: String\n) {\n  insurance_agent_connection(where: {id: {_eq: $userId}}) {\n    edges {\n      cursor\n      node {\n        contenthtml\n        contentjson\n        userpubliccontent\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "03d3071b36268ef88b0780029fa12476";

export default node;
